/** The AI debug panel's model call list (staff only). */
export const translationsDashboard_da_aiModelCalls = {
  aiModelCallsTitle: "Modelkald",
  aiModelCallsLoading: "Indlæser modelkald",
  aiModelCallsError: "Modelkaldene kunne ikke indlæses.",
  aiModelCallsEmpty: "Ingen modelkald er registreret for denne besked. Kald gemmes i 30 dage.",
  aiModelCallFallback: "Fallback",
  aiModelCallTokensIn: "Ind",
  aiModelCallTokensOut: "Ud",
  aiModelCallTokensCached: "Cachet",
  aiModelCallLoading: "Indlæser kald",
  aiModelCallError: "Kaldet kunne ikke indlæses.",
  aiModelCallTruncated:
    "Det gemte indhold blev forkortet: {{instruction}} tegn blev skåret af slutningen af instruktionen og {{response}} af svaret.",
  aiModelCallInstruction: "Instruktion",
  aiModelCallCopyInstruction: "Kopiér instruktion",
  aiModelCallInput: "Input",
  aiModelCallCopyInput: "Kopiér input",
  aiModelCallConversation: "Samtalen som sendt",
  aiModelCallNoConversation: "Der blev ikke sendt nogen samtalebeskeder.",
  aiModelCallMessageUser: "Bruger",
  aiModelCallMessageModel: "Model",
  aiModelCallResponse: "Råt svar",
  aiModelCallCopyResponse: "Kopiér råt svar",
  aiModelCallCopied: "Kopieret",
  aiModelCallReplayTitle: "Kør igen",
  aiModelCallEditInstruction: "Redigér instruktion",
  aiModelCallReplayInstructionLabel: "Instruktion til genkørslen",
  aiModelCallReplayButton: "Kør igen",
  aiModelCallReplaying: "Kører igen...",
  aiModelCallReplayRateLimited:
    "For mange genkørsler. Du kan køre 10 kald igen i minuttet og 200 om dagen.",
  aiModelCallReplayTooLong: "Instruktionen er for lang til at køre igen (højst 400.000 tegn).",
  aiModelCallReplayUnsupported: "Genkørsel er ikke muligt for AWS Bedrock-kald.",
  aiModelCallReplayFailed: "Genkørslen mislykkedes. Prøv igen senere.",
  aiModelCallOriginalResponse: "Oprindeligt råt svar",
  aiModelCallReplayAnswer: "Nyt svar",
  aiModelCallCopyReplayAnswer: "Kopiér nyt svar",
  aiModelCallDuration: "Tid",
  aiModelCallRoleRouting: "Fordeling",
  aiModelCallRoleRephrase: "Omformulering",
  aiModelCallRoleMetadata: "Metadatafilter",
  aiModelCallRoleLanguage: "Sproggenkendelse",
  aiModelCallRoleRag: "Svar med viden",
  aiModelCallRoleSimple: "Simpelt svar",
  aiModelCallRoleImage: "Billedsvar",
  aiModelCallRoleSuggestion: "Foreslåede spørgsmål",
  aiModelCallRolePlanner: "API-planlægger",
  aiModelCallRoleAnswer: "Svar",
};
